import { SET_ERROR_MESSAGE } from './ErrorPageConstants'

const initialState = {
  error: '',
}

export const errorPageReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }

    default: {
      return state
    }
  }
}
